import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  CustomInput,
} from "reactstrap";

const AddFeedPreviewModal = ({
  isOpen,
  previewImageUrl,
  previewVideoUrl,
  toggle,
  editMode,
  onChangePreview,
  resetPreview,
  postCost,
  plusPostPrice,
  premiumPostPrice,
}) => {
  const [showPreview, setShowPreview] = useState("previewImageUrl");

  const _closeModal = () => {
    setShowPreview("previewImageUrl");
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => _closeModal()}
      className="modal-dialog-centered modal-dialog-scrollable"
    >
      <ModalHeader toggle={() => _closeModal()}>
        {editMode ? "Update" : "Add"} Preview
      </ModalHeader>

      <ModalBody>
        <FormGroup tag="fieldset" className="mb-3">
          <CustomInput
            type="radio"
            id="customRadio_AddFeedPreviewModal_previewImageUrl"
            name="preview"
            value="previewImageUrl"
            onChange={(e) => setShowPreview("previewImageUrl")}
            checked={showPreview === "previewImageUrl"}
            label={`Upload Preview Image ${
              showPreview !== "previewImageUrl" &&
              (previewImageUrl?.previewBlob || previewImageUrl?.uploadUrl)
                ? "(Added)"
                : ""
            } `}
          />
          {postCost || plusPostPrice || premiumPostPrice ? (
            <CustomInput
              type="radio"
              id="customRadio_AddFeedPreviewModal_previewVideoUrl"
              name="preview"
              value="previewVideoUrl"
              className="mt-2"
              onChange={(e) => setShowPreview("previewVideoUrl")}
              checked={showPreview === "previewVideoUrl"}
              label={`Upload Preview Video ${
                showPreview !== "previewVideoUrl" &&
                (previewVideoUrl?.previewBlob || previewVideoUrl?.uploadUrl)
                  ? "(Added)"
                  : ""
              } `}
            />
          ) : null}
        </FormGroup>

        {showPreview === "previewImageUrl" ? (
          <>
            <div>
              {previewImageUrl?.previewBlob || previewImageUrl?.uploadUrl ? (
                <img
                  width="100%"
                  src={
                    previewImageUrl?.previewBlob || previewImageUrl?.uploadUrl
                  }
                  alt="preview"
                  loading="lazy"
                  className="previewImgInModal"
                />
              ) : null}
              {!(previewImageUrl?.previewBlob || previewImageUrl?.uploadUrl) ? (
                <Label className="themeBtn addBtn d-block mx-auto">
                  <input
                    type="file"
                    style={{ display: "none" }}
                    accept="image/*"
                    onChange={(e) => onChangePreview("previewImageUrl", e)}
                  />
                  Upload Preview Image
                </Label>
              ) : null}
            </div>{" "}
            {previewImageUrl?.previewBlob || previewImageUrl?.uploadUrl ? (
              <Label className="themeBtn addBtn d-block mx-auto mt-3">
                <input
                  type="file"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) => onChangePreview("previewImageUrl", e)}
                />
                Change Preview Image
              </Label>
            ) : null}
          </>
        ) : null}

        {showPreview === "previewVideoUrl" ? (
          <>
            <div>
              {previewVideoUrl?.previewBlob || previewVideoUrl?.uploadUrl ? (
                <video
                  width="100%"
                  src={
                    previewVideoUrl?.previewBlob || previewVideoUrl?.uploadUrl
                  }
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                />
              ) : null}
              {!(previewVideoUrl?.previewBlob || previewVideoUrl?.uploadUrl) ? (
                <Label className="themeBtn addBtn d-block mx-auto mb-1">
                  <input
                    type="file"
                    style={{ display: "none" }}
                    accept="video/*"
                    onChange={(e) => onChangePreview("previewVideoUrl", e)}
                  />
                  Upload Preview Video
                </Label>
              ) : null}
            </div>{" "}
            {previewVideoUrl?.previewBlob || previewVideoUrl?.uploadUrl ? (
              <Label className="themeBtn addBtn d-block mx-auto mt-3">
                <input
                  type="file"
                  style={{ display: "none" }}
                  accept="video/*"
                  onChange={(e) => onChangePreview("previewVideoUrl", e)}
                />
                Change Preview Video
              </Label>
            ) : null}
          </>
        ) : null}
      </ModalBody>

      <ModalFooter>
        <Button className="modalBtnCancel" onClick={() => _closeModal()}>
          Close
        </Button>
        <Button
          className="modalBtnSave"
          onClick={() => resetPreview(showPreview)}
        >
          Reset
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddFeedPreviewModal;
